<template>
  <v-layout align-center justify-center>
    <v-flex xs12 sm10 md8 lg6>
      <v-card class="elevation-12" align-center justify-center>
        <v-toolbar dark color="primary">
        </v-toolbar>
        <v-img
          src="/static/img/logo.png"
          height="250"
          contain
          pt-5
        ></v-img>

        <div class="headline text-xs-center mb-4">RENO RODEO ASSOCIATION WRANGLER APPLICATION</div>
        <div class="title text-xs-center">WELCOME TO THE RENO RODEO ASSOCIATION</div>

        <div v-if="saved" class="mb-4">
          <div class="title mx-4">
            <p>Your application has been accepted. Someone from the Manpower Committee will be in touch.</p>
          </div>
        </div>
        <div v-else>
          <v-form
              ref="form"
              v-model="valid"
              lazy-validation
          >
          <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-flex xs12>
                      <p class="title">Congratulations on taking that first step toward membership by becoming a Wrangler with the Reno Rodeo. You
                        must be at least 18 years of age and attend an orientation session, held shortly before the rodeo. Once you have
                        completed two consecutive rodeos <u>in good standing</u> and have reached the age of 21, <u>you may be considered</u> for
                        membership.</p>

                        <div class="title text-xs-center font-weight-bold pt-4">Please Print Clearly</div>
                    </v-flex>
                    <v-flex xs12>
                      <v-layout wrap>
                        <v-flex xs12 md8 order-xs2 order-md1>
                          <v-flex xs12>
                            <v-layout wrap>
                              <v-flex xs10 md5>
                                <v-text-field
                                  v-model="editedItem.firstName"
                                  @keyup.enter="save"
                                  label="First Name"
                                  ref="focusName"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs2 md1>
                                <v-text-field
                                  v-model="editedItem.middle"
                                  @keyup.enter="save"
                                  label="M"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs12 md6>
                                <v-text-field
                                  v-model="editedItem.lastName"
                                  @keyup.enter="save"
                                  label="Last Name"
                                ></v-text-field>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex xs12>
                            <v-text-field
                              v-model="editedItem.address1"
                              @keyup.enter="save"
                              label="Address"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-layout wrap>
                              <v-flex xs10 md5>
                                <v-text-field
                                  v-model="editedItem.city"
                                  @keyup.enter="save"
                                  label="City"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs2 md2>
                                <v-text-field
                                  v-model="editedItem.state"
                                  @keyup.enter="save"
                                  label="ST"
                                  mask="AA"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs12 md5>
                                <v-text-field
                                  v-model="editedItem.zip"
                                  @keyup.enter="save"
                                  label="Zipcode"
                                  mask="#####"
                                ></v-text-field>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-flex>
                        <v-flex xs12 md4 order-xs1 order-md2 class="text-xs-center text-sm-center text-md-center text-lg-center">
                          <v-flex xs12 text-xs-center>
                            <v-layout wrap>
                              <v-flex xs12>
                                <croppa
                                  v-model="croppa"
                                  :placeholder-font-size="14"
                                  :prevent-white-space="true"
                                  :disable-drag-and-drop="false"
                                  :width="180"
                                  :height="180"
                                  :zoom-speed="7"
                                >
                                </croppa>
                              </v-flex>
                              <v-flex xs12>
                                <v-btn
                                  flat
                                  icon
                                  color="primary"
                                  small
                                  @click="croppa.rotate(-1)"
                                >
                                  <v-icon>rotate_left</v-icon>
                                </v-btn>
                                <v-btn
                                  flat
                                  icon
                                  color="primary"
                                  small
                                  @click="croppa.rotate()"
                                >
                                  <v-icon>rotate_right</v-icon>
                                </v-btn>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-select
                      :items="mobileTypes"
                      v-model="editedItem.MobileTypeId"
                      menu-props="auto"
                      label="Mobile Type"
                      hide-details
                      prepend-icon="mdi-cellphone-cog"
                      @keyup.enter="save"
                    ></v-select>
                  </v-flex>
                    <v-flex xs12 md6>
                      <v-text-field
                        v-model="editedItem.cellPhone"
                        @keyup.enter="save"
                        label="Mobile"
                        mask="(###) ###-####"
                        return-masked-value
                        prepend-icon="stay_current_portrait"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-text-field
                        v-model="editedItem.homePhone"
                        @:keyup.enter="save"
                        label="Home"
                        mask="(###) ###-####"
                        return-masked-value
                        prepend-icon="phone"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-text-field
                        v-model="editedItem.workPhone"
                        @keyup.enter="save"
                        label="Work"
                        mask="(###) ###-####"
                        return-masked-value
                        prepend-icon="business"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6 md3>
                      <v-menu
                        :close-on-content-click="false"
                        v-model="menu1"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <v-text-field
                          slot="activator"
                          v-model="formattedDate"
                          label="Birth Date"
                          prepend-icon="cake"
                          hint="MM/DD/YYYY format"
                          persistent-hint
                          @change="editedItem.birthDate = parseDate(formattedDate)"
                        ></v-text-field>
                        <v-date-picker
                          ref="picker"
                          v-model="editedItem.birthDate"
                          no-title
                          :max="new Date().toISOString().substr(0, 10)"
                          @input="menu1 = false"
                          @change="formattedDate = formatDate(editedItem.birthDate)"
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        prepend-icon="email"
                        label="Email"
                        type="email"
                        v-model="editedItem.email"
                        :rules="emailRules"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        v-model="editedItem.iceName"
                        label="Emergency Contact Name"
                        :rules="[v => !!v || 'Emergency Contact Name is required']"
                        required
                      ></v-text-field>
                    </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      v-model="editedItem.icePhone"
                      label="Emergency Contact Phone"
                      mask="(###) ###-####"
                      return-masked-value
                      prepend-icon="stay_current_portrait"
                      :rules="[v => !!v || 'Emergency Contact Phone is required']"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <div class="title text-xs-center font-weight-bold py-4">PLEASE READ CAREFULLY</div>

                    <ul>
                      <li>Please submit this application <u>with a $25.00 fee</u> to the rodeo office, along with a photocopy of your driver's license or personal ID.</li>
                      <li>If you are in the military, please also include a copy of your military ID.</li>
                      <li>An application <u>will not be accepted</u> without the application fee, or a headshot</li>
                      <li>Reno Rodeo Association Wranglers or Members may not, <u>at any time</u>, consume, possess, or handle illegal substances (drugs), and if under
                        21 years of age, consume alcoholic beverages on the rodeo grounds. Violation of this rule will result in <u>immediate and permanent</u> dismissal.</li>
                        <li>Note that you <u>do not</u> automatically become a RR Member after two rodeos as a Wrangler. To be considered for membership, you must first serve as
                          a Wrangler for two consecutive rodeos. During that time, you will be evaluated on your performance and hours of service. Once you have attained
                          the age of 21, and have successfully completed these requirements, you may be considered for membership.</li>
                    </ul>

                    <p class="mt-4"><b>You must bring a photocopy of your driver's license or personal ID to the Reno Rodeo Office or the Wrangler Orientation!</b></p>
                  </v-flex>
                  <v-flex class="title text-xs-center mt-4" xs12>
                    <span class="blue--text">CREDIT CARD INFORMATION</span>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="editedItem.number"
                      label="Credit Card Number"
                      :rules="[v => !!v || 'Credit Card Number is required']"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="editedItem.cardName"
                      label="Name on Card"
                      :rules="[v => !!v || 'Name on Card is required']"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md3>
                    <v-text-field
                      v-model="editedItem.expire"
                      label="Expires"
                      mask="##/##"
                      return-masked-value
                      :rules="[v => !!v || 'Expires is required']"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md3 offset-md1>
                    <v-text-field
                      v-model="editedItem.cvv"
                      label="CVV"
                      mask="####"
                      :rules="[v => !!v || 'CVV is required']"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md3 offset-md1>
                    <v-text-field
                      v-model="editedItem.amount"
                      label="Amount"
                      :rules="[v => !!v || 'Amount is required']"
                      mask="###.##"
                      prefix="$"
                      readonly
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            <v-alert :value="error" type="warning" transition="scale-transition">
              <span v-html="error"></span>
            </v-alert>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
              <v-checkbox
                v-model="checkbox"
                label="I have read and release liability on behalf of the Reno Rodeo Association!"
                :rules="[v => !!v || 'You must agree to continue!']"
                required
              ></v-checkbox>
            <v-btn color="primary" @click="save">Submit</v-btn>
          </v-card-actions>
        </v-form>
        </div>
      </v-card>
    </v-flex>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line=true
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn
        dark
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'
import Utilities from '@/services/Utilities'
import 'vue-croppa/dist/vue-croppa.css'
import moment from 'moment'

export default {
  data () {
    return {
      menu1: false,
      valid: true,
      currentYear: 0,
      checkbox: false,
      dates: [],
      saved: false,
      editedItem: {
        amount: '25'
      },
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid'
      ],
      error: null,
      formattedDate: '',
      croppa: {},
      mobileTypes: [],
      snackbar: {
        show: false,
        color: '',
        message: ''
      }
    }
  },

  filters: {
    formatDate (value) {
      if (value) {
        return moment(String(value)).format('MM/DD/YYYY')
      }
    }
  },

  created () {
    this.getMobileTypes()
  },

  watch: {
    menu1 (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    }
  },

  methods: {
    formatDate (date) {
      return Utilities.displayDate(date)
    },

    parseDate (date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    async getMobileTypes () {
      try {
        const response = await Api().get('mobiletypes')
        this.mobileTypes = response.data
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    async save () {
      try {
        this.editedItem.dataUrl = this.croppa.generateDataUrl('image/jpeg', 0.8)
        this.editedItem.fullName = this.editedItem.firstName + ' ' + this.editedItem.lastName
        this.editedItem.startDate = 2023
        this.editedItem.RoleId = 2
        this.editedItem.TitleId = 17
        this.editedItem.status = 'inactive'
        // this.editedItem.Title.name = 'New Wrangler'

        if (this.$refs.form.validate()) {
          const response = await Api().post('wrangler', this.editedItem)
          this.editedItem = {}

          this.saved = true

          this.snackbar.message = response.data.message + ' Congratulation, your Application has been submitted!'
          this.snackbar.color = 'success'
          this.snackbar.show = true
        } else {
          this.snackbar.message = 'You have some errors on the page!'
          this.snackbar.color = 'error'
          this.snackbar.show = true
        }
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.centered-input input {
  text-align: center
}

.croppa-container {
  background-color: white;
  border: 3px solid black
}

.scroll-here {
  overflow: auto;
  height: 340px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/wrangler/ExternalForm.vue